<template>
    <div>
        <div class="form-inline">
            <div class="form-group">
                <input id="filter-{{ _uid }}-min"
                       type="number"
                       step="1"
                       placeholder="Min"
                       v-model="selection[0]"
                       class="form-control">
            </div>
            <div class="form-group">
                <input id="filter-{{ _uid }}-min"
                       type="number"
                       step="1"
                       placeholder="Max"
                       v-model="selection[1]"
                       class="form-control">
            </div>
        </div>
    </div>
</template>

<style scoped>
    input {
        max-width: 140px;
    }
</style>

<script type="text/ecmascript-6">
    import CheckboxGroup from 'vue-strap/src/checkboxGroup';
    import CheckboxBtn from 'vue-strap/src/checkboxBtn';

    export default {
        components: {
            CheckboxGroup,
            CheckboxBtn
        },
        props: {
            filter: {
                required: true
            },
            selection: {
                twoWay: true,
                required: true
            }
        }
    };
</script>



// WEBPACK FOOTER //
// RangeFilter.vue?80e29090